module.exports = __webpack_public_path__ + "img/HHEmleklap2021h.96f23e0b.jpg";